"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Sorter =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Sorter, _PureComponent);

  function Sorter(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleAsc = _this.handleAsc.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleDesc = _this.handleDesc.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Sorter.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.defaultSorterOrder();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.defaultSorterOrder();
  };

  _proto.defaultSorterOrder = function defaultSorterOrder() {
    var _this$props = this.props,
        defaultOrder = _this$props.defaultOrder,
        current = _this$props.current,
        index = _this$props.index;
    if (current.length !== 1) return;
    var item = current[0];
    var changed = index === item.index && defaultOrder === item.order;
    if (defaultOrder && !changed && !item.manual) this.handleChange(defaultOrder, false);
  };

  _proto.handleChange = function handleChange(order, manual) {
    if (manual === void 0) {
      manual = true;
    }

    var _this$props2 = this.props,
        sorter = _this$props2.sorter,
        index = _this$props2.index,
        onChange = _this$props2.onChange,
        current = _this$props2.current;
    var item = current.find(function (v) {
      return v.index === index;
    });
    var isCancel = !!item && order === item.order;
    var finalOrder = isCancel ? undefined : order;
    onChange(finalOrder, sorter, index, order, manual);
  };

  _proto.handleAsc = function handleAsc() {
    this.handleChange('asc');
  };

  _proto.handleDesc = function handleDesc() {
    this.handleChange('desc');
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        current = _this$props3.current,
        index = _this$props3.index;
    var item = current.find(function (v) {
      return v.index === index;
    });
    var active = !!item;
    return _react.default.createElement("div", {
      className: (0, _styles.tableClass)('sorter-container')
    }, _react.default.createElement("a", {
      key: "asc",
      className: (0, _styles.tableClass)(active && item.order === 'asc' && 'sorter-active', 'sorter-asc'),
      onClick: this.handleAsc
    }, "\xA0"), _react.default.createElement("a", {
      key: "desc",
      className: (0, _styles.tableClass)(active && item.order === 'desc' && 'sorter-active', 'sorter-desc'),
      onClick: this.handleDesc
    }, "\xA0"));
  };

  return Sorter;
}(_react.PureComponent);

Sorter.propTypes = {
  current: _propTypes.default.array,
  index: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func.isRequired,
  sorter: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]).isRequired,
  defaultOrder: _propTypes.default.oneOf(['desc', 'asc'])
};
var _default = Sorter;
exports.default = _default;